import ValidateGlobal from './../ValidateGlobal.js'
import ServiceGlobal from './../InputsServiceGlobal.js'
export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: [String, Object, Number]
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: [String, Object, Number]
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      value: this.modelProps !== undefined && this.modelProps !== null && !(typeof this.modelProps === 'object' && this._.isEmpty(this.modelProps)) ? this.modelProps : undefined,
      options: this.config.datasource.options ? this._.cloneDeep(this.config.datasource.options) : [],
      filterOptions: []
    }
  },
  async created () {
    this.internalScaffolding.isLoading = this.internalScaffolding.isLoading ? this.internalScaffolding.isLoading : true
    if (this.config.datasource.hasOwnProperty('path')) {
      let pathSplited = this.config.datasource.path.split('/')
      let res = await this.$query(pathSplited)
      if (res) {
        this.options = res.hasOwnProperty(this.config.datasource.field) ? res[this.config.datasource.field] : this._.values(this._.omit(res, 'metaData'))
      }
    }
    this.initOptions()
    this.internalScaffolding.isLoading = false
  },
  computed: {
    validationRules () {
      return this.expressionResolver(this.config.validation)
    },
    keyByOptions() {
      let valueField = this.R.path(['datasource', 'value'], this.config)
      return this.filterOptions ? this._.keyBy(this.filterOptions, valueField) : {}
    },
    innerValue() {
      return this.$refs[this._uid] ? this.$refs[this._uid].innerValue : null
    }
  },
  watch: {
    value: {
      handler: function (newValue, oldValue) {
        if (this.config.isMerge) {
          if(!newValue && oldValue && this.options[0]) {
            Object.keys(this.options[0]).forEach(key => delete oldValue[key])
            newValue = oldValue
          }
          this.$emit('input', this._.merge(this.modelProps, newValue))
        } else {
          this.$emit('input', newValue)
        }
        if(this.config.subribers) {
          this.$emit('command', { cmd: 'notify-subriber', payload : this.config.subribers })
        }
      },
      deep: true
    },
    'config.datasource.options': {
      handler: function (newValue, oldValue) {
        if(!this._.isEqual(newValue, oldValue)) {
          this.options = this.R.clone(newValue)
          this.initOptions()
        }
      },
      deep: true
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    filterFn (val, update, abort) {
      let vm = this
      update(() => {
        if (val === '') {
          vm.filterOptions = vm.R.clone(vm.options)
          this.sortOptions()
        } else {
          const needle = val.toLowerCase()
          vm.filterOptions = vm.R.clone(vm.options).filter(
            v => v[vm.config.datasource.label].toLowerCase().indexOf(needle) > -1
          )
          vm.sortOptions()
        }
      })
    },
    validate () {
      this.$refs[this._uid].$emit('submitEvent', this.value)
    },
    ramda() {
      return this.R
    },
    picker() {
      let vm = this
      if (this.config.datasource.pickNext && this.config.datasource.pickNext.pickDefault && this.options) {
        let pickField = this.R.path(['datasource', 'value'], this.config)
        if (this.originModel) {
          let temp = this._.cloneDeep(this.options.filter(item => vm.R.path(vm.R.flatten([pickField]), item) === vm.R.path(vm.R.flatten([pickField]), vm.originModel)))
          this.options = this._.values(this._.pick(this._.keyBy(this.options, pickField), temp.length > 0 ? temp[0].next : []))
        } else {
          this.options = this._.values(this._.pick(this._.keyBy(this.options, pickField), this.config.datasource.pickNext.pickDefault))
        }
      }
    },
    sortOptions() {
      let vm = this
      if (vm.config.sortBy) {
        let sortBy = vm.R.flatten([vm.config.sortBy])
        vm.filterOptions = vm.filterOptions.sort((a, b) => {
          let getFieldA = vm.R.path(sortBy, vm.config.asc ? b : a)
          let getFieldB = vm.R.path(sortBy, vm.config.asc ? a : b)
          return typeof getFieldA === typeof getFieldB === 'string'? getFieldA.localeCompare(getFieldB) :
            (getFieldA > getFieldB ? 1 : getFieldA < getFieldB ? -1 : 0)
        })
      }
    },
    filterDatasource() {
      if(this.config.datasource.filterFn) {
        return this.options.filter(this.config.datasource.filterFn)
      }
      return this.options
    },
    initOptions() {
      this.options = this.filterDatasource()
      this.picker()
      this.filterOptions = Array.isArray(this.options) ? this.R.clone(this.options) : []
      this.sortOptions()
      this.defaultValue()
    },
    defaultValue() {
      if(this.config.default && !this.modelProps) {
        this.value = this.config.datasource.emitValue ? this.config.default : this._.find(this.filterOptions, this.config.default)
      }
    }
  }
}
